
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.65 12.922c-2.1-3.7-6.6-5.6-10.7-4.3-3.8 1.2-5.7 4.5-6.3 8.1h-6.4c-1.7-2.7-3.4-5.5-5.1-8.3-.4-.8-.8-1.9-1.6-2.2-1.2-.5-3.5 0-4.8 0-1 0-1 3.2 0 3.2 1.4 0 3.3-.3 4.7 0 .1.1.2.3.2.4.3.6.8 1.2 1.1 1.8 1.1 1.7 2.1 3.4 3.2 5.2h-9.1c-1.1 0-.6 2.4-.4 2.9.9 1.6 1.9 3.2 2.8 4.9.1.2.2.4.3.5 3.4 5.8 6.7 11.6 10.1 17.5v8.5h-4.2c-1 0-1 3.1 0 3.1h9.9c1 0 1-3.1 0-3.1h-4.2v-8.5l8.7-15c8.8 4 16.5-6.5 11.8-14.7zm-21.4 26.9c-2.9-5-5.8-10.1-8.7-15.1 4.2-.9 7.8-.4 12.2-.1 1.7.1 3.6.2 5.4 0-3 5-5.9 10.1-8.9 15.2zm11-19c-2.7 1.1-6.2.8-9 .5-4.4-.5-8-.6-12.3.6-.4-.7-.8-1.3-1.1-2h22.9c-.2.3-.3.6-.5.9zm7.4 3c-2.3 1.7-5 1.9-7.5 1.1.2-.4.5-.8.7-1.2.1-.1.2-.3.3-.5.7-1.2 1.4-2.3 2-3.5.3-.5.7-2.9-.4-2.9h-7.6c1.6-5.7 9.7-7.2 13.7-2.8 2.8 3 2 7.4-1.2 9.8z"}})])
          )
        }
      }
    